import { render, staticRenderFns } from "./insights-sessions.vue?vue&type=template&id=597ec4ca&scoped=true&"
import script from "./insights-sessions.vue?vue&type=script&lang=js&"
export * from "./insights-sessions.vue?vue&type=script&lang=js&"
import style0 from "./insights-sessions.vue?vue&type=style&index=0&id=597ec4ca&prod&lang=scss&"
import style1 from "./insights-sessions.vue?vue&type=style&index=1&id=597ec4ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ec4ca",
  null
  
)

export default component.exports